"use strict";
//When adding constants, create objects to group them by type.
//The objects should be alphabetical in the file.
//The object properties should be kept alphabetical by name within the object defineProperty lines
//If you are creating a new constant group, make sure to add it to the Exports.

var constants = {
	mappings: [],
	add: function (type, name, value) {
		this.mappings.push({ type: type, name: name, value: value });
	}
};

var BluefinErrorCodes = {};
constants.add(BluefinErrorCodes, "BlankField", 1000);
constants.add(BluefinErrorCodes, "InputTooShort", 1001);
constants.add(BluefinErrorCodes, "InputTooLong", 1002);
constants.add(BluefinErrorCodes, "InputNotNumeric", 1003);
constants.add(BluefinErrorCodes, "InvalidCreditCard", 1004);
constants.add(BluefinErrorCodes, "InvalidExpiration", 1005);

var BluefinFieldNames = {};
constants.add(BluefinFieldNames, "CreditCard", "number");
constants.add(BluefinFieldNames, "Cvv", "cvv");
constants.add(BluefinFieldNames, "Expiration", "expy");
constants.add(BluefinFieldNames, "BankAccount", "bank account");
constants.add(BluefinFieldNames, "RoutingNumber", "routing number");

var CheckoutTypes = {};
constants.add(CheckoutTypes, "ApplePay", "ApplePay");
constants.add(CheckoutTypes, "GooglePay", "GooglePay");
constants.add(CheckoutTypes, "PayPal", "PayPal");

var CreditCardProviders = {};
constants.add(CreditCardProviders, "Bluefin", "BLUE");
constants.add(CreditCardProviders, "Braintree", "BRAINTREE");
constants.add(CreditCardProviders, "CardConnect", "CCONNECT");
constants.add(CreditCardProviders, "CyberSource", "CYB_SOURCE");
constants.add(CreditCardProviders, "Tsys", "TSYS");

var OneTimePasswordTypes = {};
constants.add(OneTimePasswordTypes, "GuestCheckout", "GuestCheckout");
constants.add(OneTimePasswordTypes, "CreateAccount", "CreateAccount");

var ReCAPTCHAActions = {};
constants.add(ReCAPTCHAActions, "AdminLogin", "admin_login");
constants.add(ReCAPTCHAActions, "AppleCheckout", "apple_checkout");
constants.add(ReCAPTCHAActions, "Checkout", "checkout");
constants.add(ReCAPTCHAActions, "Contact", "contact");
constants.add(ReCAPTCHAActions, "EmailSubscriptionSignup", "email_subscription_signup");
constants.add(ReCAPTCHAActions, "GoogleCheckout", "google_checkout");
constants.add(ReCAPTCHAActions, "Login", "login");
constants.add(ReCAPTCHAActions, "PasswordReset", "password_reset");
constants.add(ReCAPTCHAActions, "PaymentAdd", "payment_add");
constants.add(ReCAPTCHAActions, "PaypalCheckout", "paypal_checkout");
constants.add(ReCAPTCHAActions, "PledgeStatementCheckout", "pledge_statement_checkout");
constants.add(ReCAPTCHAActions, "Signup", "signup");
constants.add(ReCAPTCHAActions, "UpdateAccount", "update_account");

//Function that actually applies all of the properties to the objects.
constants.mappings.forEach((constant) => {
	Object.defineProperty(constant.type, constant.name, { value: constant.value, writable: false, enumerable: true, configurable: true });
});

module.exports = {
	BluefinErrorCodes,
	BluefinFieldNames,
	CheckoutTypes,
	CreditCardProviders,
	OneTimePasswordTypes,
	ReCAPTCHAActions
};
